import React, {useState} from "react";
import "./SidePanel.scss";

function SidePanel() {
  const [open, setOpen] = useState(false);

  const openPanel = () => setOpen(true);
  const closePanel = () => setOpen(false);

  return (
    <>
      <div
        className={`sidepanel ${open ? "open" : ""}`}
        onMouseLeave={closePanel}
      >
        <button className="closebtn" onClick={closePanel}>
          &times;
        </button>
        <iframe
          src="https://imrtequila.me"
          title="imrtequila"
          width="100%"
          height="100%"
          frameBorder="0"
        ></iframe>
      </div>
      {!open && <div className="hover-area" onMouseEnter={openPanel}></div>}
    </>
  );
}

export default SidePanel;
